<div
	class="rounded-lg sm:rounded-xl border border-gray-200 bg-white shadow-sm p-3 sm:p-4 w-full sm:max-w-xs flex flex-col gap-3"
>
	<div class="flex items-start justify-between gap-2">
		<div class="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
			<div class="bg-purple-100 text-purple-600 rounded-lg p-2 flex items-center justify-center shrink-0">
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 sm:w-7 sm:h-7">
					<path stroke-linecap="round" stroke-linejoin="round" d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-4.5-6h.75m3.75 0h.75m-3 0h.75m7.5-6.75v12a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 18V5.25A2.25 2.25 0 016.75 3h12a2.25 2.25 0 012.25 2.25z" />
				</svg>
			</div>
			<div class="min-w-0 flex-1">
				<div class="font-semibold text-gray-900 text-sm sm:text-base truncate">
					{{ promocion().nombre }}
				</div>
				<div class="text-gray-500 text-xs sm:text-sm truncate">
					{{ promocion().tipo_documento === 'TODOS' ? 'Todos los documentos' : promocion().tipo_documento }}
				</div>
			</div>
		</div>
		<span
			class="text-xs font-medium px-2 sm:px-3 py-1 rounded-full whitespace-nowrap shrink-0"
			[class.bg-green-100]="promocion().activo === true"
			[class.text-green-700]="promocion().activo === true"
			[class.bg-red-100]="promocion().activo !== true"
			[class.text-red-700]="promocion().activo !== true"
		>
			{{ promocion().activo === true ? 'Activo' : 'Inactivo' }}</span
		>
	</div>

	@if (promocion().monto_minimo !== null && promocion().monto_minimo !== undefined) {
		<div class="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2 mt-1">
			<span class="text-gray-500 text-sm">Monto mínimo</span>
			<span class="text-gray-700 font-medium text-sm">S/ {{ promocion().monto_minimo }}</span>
		</div>
	}

	<div class="flex flex-col sm:flex-row gap-2 mt-2">
		<button
			class="flex-1 flex items-center justify-center gap-1 bg-blue-50 text-blue-600 hover:bg-blue-100 font-medium py-2.5 rounded-lg transition-colors active:scale-95 text-xs sm:text-sm"
			(click)="onEditar()"
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 sm:w-5 sm:h-5">
				<path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487a2.25 2.25 0 113.182 3.182L7.5 20.213l-4.182 1 1-4.182L16.862 4.487z" />
			</svg>
			Editar
		</button>
		@if (promocion().activo === true) {
			<button
				class="flex items-center justify-center font-medium py-2.5 px-3 rounded-lg transition-colors bg-red-50 text-red-600 hover:bg-red-100 active:scale-95 sm:w-auto w-full"
				(click)="toggleStatus()"
			>
				<i class="bi bi-x-lg"></i>
				<span class="inline md:hidden">Desactivar</span>
			</button>
		} @else {
			<button
				class="flex items-center justify-center font-medium py-2.5 px-3 rounded-lg transition-colors bg-green-50 text-green-600 hover:bg-green-100 active:scale-95 sm:w-auto w-full"
				(click)="toggleStatus()"
			>
				<i class="bi bi-check-lg"></i>
				<span class="inline md:hidden">Activar</span>
			</button>
		}
	</div>
</div>

<app-dialog
	header="Editar promoción de impresora"
	[modal]="true"
	[(visible)]="modal_editar"
	(onHide)="modal_editar.set(false)"
	size="md"
>
	@if (modal_editar()) {
		<app-editar-promocion-impresora [promocion]="promocion()" (cerrar)="closeEditar($event)" />
	}
</app-dialog>
